import CustomDrawer from "../shared/CustomDrawer";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserAPIs } from "../../api/APIs";
import { useEffect, useState } from "react";
import { removeNonNumeric } from "../../utils/Utils";
import { isValidPhoneNumber } from "../../utils/validations";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { LoadingButton } from "@mui/lab";
import CancelOutlined from "@mui/icons-material/CancelOutlined";
import { useOutletContext } from "react-router-dom";

export function MobileNoBottomSheet(props) {
  const { open, setOpen, mobileNo, setMobileNo, submit } = props;
  const { editableSubscription } = useOutletContext();
  const [editedMobileNo, setEditedMobileNo] = useState(mobileNo || "");
  const { loading, apiCall: setSubscription } = useRequest(
    BalootUserAPIs.setSubscription
  );

  useEffect(() => {
    setEditedMobileNo(mobileNo || "");
  }, [mobileNo]);

  const onSubmit = () => {
    setSubscription({
      data: {
        bankId: editableSubscription.bank.id,
        day: editableSubscription.day,
        limit: editableSubscription.amount,
        period: editableSubscription.period,
        mobile: editedMobileNo,
      },
      onSuccess: (response) => {
        setMobileNo(editedMobileNo);
        setOpen(false);
        submit(response);
      },
    });
  };

  return (
    <>
      <CustomDrawer
        open={open}
        onClose={() => {
          setEditedMobileNo(mobileNo || "");
          setOpen(false);
        }}
      >
        {mobileNo ? (
          <Typography mt={1} variant="h5" color="grey.2">
            شماره موبایل وارد شده
            <Box component="span" display="inline" color="primary.main">
              {` "${mobileNo}" `}
            </Box>
            است.اگر شماره موبایل متصل به
            <Box component="span" display="inline" color="primary.main">
              {` "${editableSubscription.bank.name}" `}
            </Box>
            متفاوت است آن را وارد کنید.
          </Typography>
        ) : (
          <Typography mt={1} variant="h5" color="grey.2">
            شماره موبایلی ثبت نشده. لطفا شماره موبایل خود را وارد کنید
          </Typography>
        )}

        <TextField
          name="mobile"
          inputProps={{
            inputMode: "numeric",
          }}
          error={
            editedMobileNo.length === 11 && !isValidPhoneNumber(editedMobileNo)
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {editedMobileNo.length > 0 && (
                  <IconButton
                    onClick={() => {
                      setMobileNo("");
                    }}
                  >
                    <CancelOutlined sx={{ fontSize: 20 }} />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
          value={editedMobileNo}
          onChange={(event) => {
            if (event.target.value === null) {
              setEditedMobileNo("");
            } else {
              event.target.value.length < 12 &&
                setEditedMobileNo(removeNonNumeric(event.target.value));
            }
          }}
          sx={{ mt: "12px" }}
          fullWidth
          placeholder="شماره تلفن همراه خود را وارد نمایید"
        />

        <LoadingButton
          onClick={onSubmit}
          loading={loading}
          disabled={
            !editedMobileNo ||
            editedMobileNo.length < 11 ||
            !isValidPhoneNumber(editedMobileNo)
          }
          sx={{
            mt: 2,
            color: "common.white",
            typography: "h3",
          }}
          variant="contained"
          fullWidth
        >
          ثبت
        </LoadingButton>
      </CustomDrawer>
    </>
  );
}
